module.exports = __webpack_public_path__ + "7da3159a1f187dc289a21b12a39ce1ce.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BO.svg
// module id = 7mSs
// module chunks = 0